let vendorPath = "/local/templates/main2023/static/vendor/"

window.addScript = function (src, callback) {
    var s = document.createElement('script');
    s.setAttribute('src', src);
    s.onload = callback;
    document.body.appendChild(s);
}

window.addEventListener('load', function (e) {
    addScript(vendorPath + 'fancybox.umd.js', function () {
        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
    });

    $('.js-select').select2({
        minimumResultsForSearch: Infinity
    });
});

document.addEventListener("DOMContentLoaded", function (event) {
    let jsMenuButton = document.querySelector('.js-mobileMenu');
    jsMenuButton.addEventListener('click', function () {
        document.querySelector('.hamburger').classList.toggle('__open');
        // document.querySelector('.mobile-line').classList.toggle('__open');
        document.querySelector('.mobile-menu__wrapper').classList.toggle('__open');
        document.querySelector('body').classList.toggle('no-scroll');
    })
});

function metrikaGoalWhatsapp() {
    if (ym && window.metrikaID) {
        ym(window.metrikaID, 'reachGoal', 'whatsapp');
    }
}